<template>
  <form action="/search" method="get" class="input-group search-form" role="search">
    <button type="submit" class="search-button">
      <IconBase icon-name="cart" width="24px" height="22px" view-box="0 0 21 21">
        <SearchIcon/>
      </IconBase>
    </button>
    <input
      @input="updateQuery"
      v-model="query"
      ref="search"
      type="search"
      name="q"
      value
      placeholder="search ‘bodysuits’"
      class="input-group-field search-field"
      aria-label="placeholder"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
    >
  </form>
</template>

<script>
import SearchIcon from './SearchIcon.vue'
import IconBase from './IconBase.vue'

export default {
  props: {
    focus: false,
  },
  data: function() {
    return {
      query: '',
    }
  },
  methods: {
    updateQuery() {
      this.$emit('search-term-update', this.query)
    },
  },
  components: {
    SearchIcon,
    IconBase,
  },
  watch: {
    focus: function() {
      if (this.focus) {
        this.$refs.search.focus()
      }
    },
  },
}
</script>
